import React from 'react';
import { useFormContext } from 'react-hook-form';
import Input from 'components/Input';
import Typography from 'components/Typography';
import classnames from 'classnames/bind';
import styles from './WelcomeBackModal.module.scss';

const cx = classnames.bind(styles);

const PasswordForm = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <div className={cx('form-wrapper')}>
      <Typography className="mgt-25">
        Passwords require:
      </Typography>
      <ul className="mgt-25 mgb-25 mgl-20">
        <li>8+ characters</li>
        <li>A capital and lowercase letter</li>
        <li>Either a number or a special character</li>
      </ul>
      <Input
        label="New Password"
        name="password"
        type="password"
        inputRef={register('password', { required: true })}
        errors={errors}
        isPassword={true}
      />
      <Input
        label="Confirm New Password"
        name="confirm_password"
        type="password"
        inputRef={register('confirm_password', { required: true })}
        errors={errors}
        isPassword={true}
      />
    </div>
  );
};

export default PasswordForm;
